import useApi from '@/Global/utilities/api'
const api = useApi

const namespaced = true
const state = {
  accessToken: '',
  userId: '',
  firstName: '',
  lastName: '',
  email: '',
  accountType: '',
  adminID: '',
  accountOwner: '',
  accountCreationDate: 0,
  accountModifiedDate: 0,
  passwordDateModified: 0,
  activeBrand: 0,
  portalName: '',
  portalDomains: [],
  accountBrands: [],
  accountGroups: [],
  isSAML: false,
  isEnterprise: false
}

const getters = {
  getAccessToken (state) {
    return state.accessToken
  },
  getUserId (state) {
    return state.userId
  },
  getFirstName (state) {
    return state.firstName
  },
  getLastName (state) {
    return state.lastName
  },
  getInitials (state) {
    return `${state.firstName[0]}${state.lastName[0]}`
  },
  getEmail (state) {
    return state.email
  },
  getAccountType (state) {
    return state.accountType
  },
  getAdminID (state) {
    return state.adminID
  },
  getAccountOwner (state) {
    return state.accountOwner
  },
  getAccountCreationDate (state) {
    return state.accountCreationDate
  },
  getAccountModifiedDate (state) {
    return state.accountModifiedDate
  },
  getPasswordDateModified (state) {
    return state.passwordDateModified
  },
  getPortalName (state) {
    return state.portalName
  },
  getPortalDomains (state) {
    return state.portalDomains
  },
  getAccountBrands (state) {
    return state.accountBrands
  },
  getAccountGroups (state) {
    return state.accountGroups
  },
  getActiveBrand (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand
  },
  getCustomerId (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.customerID
  },
  getDefaultBrandingId (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.defaultBrandingID
  },
  getBrandSupportEmail (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.defaultSupportEmail
  },
  getActiveBrandName (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.name
  },
  getBrandSecurityRestriction (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.securityRestriction.isEnabled
  },
  getBrandSiteRestriction (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.siteRestriction
  },
  getBrandBreakoutEnabled (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.features.BreakoutEnabled === 1
  },
  getBrandLiveCaptioningEnabled (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.features.LiveCaptioningEnabled === 1
  },
  getBrandMultiPresenterEnabled (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.features.MultiPresenterEnabled === 1
  },
  getBrandViewPartyEnabled (state) {
    const brand = JSON.parse(JSON.stringify(state.accountBrands[state.activeBrand]))
    return brand.features.ViewPartyEnabled === 1
  },
  getIsSAML (state) {
    return state.isSAML
  },
  getIsEnterprise (state) {
    return state.isEnterprise
  }
}

const actions = {
  commitUserInfo ({ commit }, userInfo) {
    commit('setAccessToken', userInfo.accessToken)
    commit('setFirstName', userInfo.firstName)
    commit('setLastName', userInfo.lastName)
    commit('setEmail', userInfo.email)
    commit('setAccountType', userInfo.accountType)
    commit('setAdminID', userInfo.adminID)
    commit('setAccountOwner', userInfo.accountOwner)
    commit('setAccountCreationDate', userInfo.accountCreationDate)
    commit('setAccountModifiedDate', userInfo.accountModifiedDate)
    commit('setPasswordDateModified', userInfo.passwordDateModified)
    commit('setPortalName', userInfo.portalName)
    commit('setPortalDomains', userInfo.portalDomains)
    commit('setAccountBrands', userInfo.accountBrands)
    commit('setAccountGroups', userInfo.accountGroups)
    commit('setIsSAML', userInfo.isSAML)
    commit('setIsEnterprise', userInfo.isEnterprise)
  },

  logout ({ commit }) {
    commit('setAccessToken', '')
    commit('setFirstName', '')
    commit('setLastName', '')
    commit('setEmail', '')
    commit('setAccountType', '')
    commit('setAdminID', '')
    commit('setAccountOwner', '')
    commit('setAccountCreationDate', 0)
    commit('setAccountModifiedDate', 0)
    commit('setPasswordDateModified', 0)
    commit('setPortalName', '')
    commit('setPortalDomains', [])
    commit('setAccountBrands', [])
    commit('setAccountGroups', [])
  },

  commitNameInfo ({ commit }, userInfo) {
    commit('setFirstName', userInfo.firstName)
    commit('setLastName', userInfo.lastName)
  },

  updateAndCommitUserInfo ({ dispatch }, userInfo) {
    console.log('TODO')
    // dispatch('commitUserInfo', userInfo)
  }
}

const mutations = {
  setAccessToken (state, value) {
    state.accessToken = value
    api.accessToken = value
    try {
      localStorage.setItem('accessToken', value)
    } catch (err) {
      // Localstorage is not available
    }
  },
  setUserId (state, value) {
    state.userId = value
    try {
      localStorage.setItem('userId', value)
    } catch (err) {
      // Localstorage is not available
    }
  },
  setFirstName (state, value) {
    state.firstName = value
  },
  setLastName (state, value) {
    state.lastName = value
  },
  setEmail (state, value) {
    state.email = value
  },
  setAccountType (state, value) {
    state.accountType = value
  },
  setAdminID (state, value) {
    state.adminID = value
  },
  setAccountOwner (state, value) {
    state.accountOwner = value
  },
  setAccountCreationDate (state, value) {
    state.accountCreationDate = value
  },
  setAccountModifiedDate (state, value) {
    state.accountModifiedDate = value
  },
  setPasswordDateModified (state, value) {
    state.passwordDateModified = value
  },
  setPortalName (state, value) {
    state.portalName = value
  },
  setPortalDomains (state, value) {
    state.portalDomains = value
  },
  setAccountBrands (state, value) {
    state.accountBrands = value
  },
  setAccountGroups (state, value) {
    state.accountGroups = value
  },
  setActiveBrand (state, value) {
    state.activeBrand = value
  },
  setIsSAML (state, value) {
    state.isSAML = value
  },
  setIsEnterprise (state, value) {
    state.isEnterprise = value
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced
}
